import merge from 'lodash/merge.js';
import {DeepPartial} from 'ts-essentials';

export function typesafeMerge<T>(a: T, ...sources: Array<DeepPartial<T>>): T {
  return merge(a, ...sources);
}
